import { View, ViewType } from "@common/types/views/views";

export enum HistoryTaskUpdateColumn {
    TIME = "time",
    TASK_TITLE = "taskTitle",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export interface HistoryTaskUpdateDetailsView extends View {
    type: ViewType.HISTORY_TASK_UPDATE;
    columns: Array<{ id: HistoryTaskUpdateColumn; options?: any }>;
}
